/* eslint-disable ember/classic-decorator-hooks, ember/no-mixins, ember/require-computed-property-dependencies */
import Controller from '@ember/controller';
import { computed } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { isMobile } from '@linc-technologies/linced-common/utils/platform';

export default class HomeController extends Controller.extend(EditPostMixin) {
  @service
  session;

  @service
  options;

  PersonType = PersonType;

  @tracked
  isMobile;

  init() {
    super.init(...arguments);
    this.isMobile = isMobile();
  }

  @computed('session')
  get plpLabel() {
    return (
      this.options.schoolGet(
        this.session.school,
        'core:studentGoalSetting:plpFullLabel',
      ) || 'Personal Learning Plan'
    );
  }
}
